// extracted by mini-css-extract-plugin
module.exports = {"recipe":"receipe_recipe__zVwhE","image":"receipe_image__1hYh7","li":"receipe_li__1Nye8"};